import React from "react";
import Row from "./common/Row";
import Field from "./common/Field";
import { StyleSheet, Text } from "@react-pdf/renderer";
import { config } from "./common/config";

const styles = StyleSheet.create({
  subtext: {
    color: config.grayColor,
    fontSize: config.normalFontSize + 1,
    marginBottom: 5,
  },

  subtitle: {
    width: "100%",
    borderBottomWidth: 2,
    borderBottomColor: "#118052",
    paddingBottom: 2,
    marginBottom: 4,
  },
  chatMessage: {
    // borderBottomColor: config.grayColor,
    // borderBottomWidth: 1,
    //
    backgroundColor: "#F3f3f3",
    marginBottom: 10,
    paddingTop: 5,
    paddingLeft: 5,
  },

  chatHeader: {
    paddingLeft: 5,
    backgroundColor: "#F3f3f3",
  },

  mention: {
    backgroundColor: "#d6e5fa",
  },
  subtask: {
    backgroundColor: "#40e5a0",
    fontWeight: "bold",
  },
});

const reformatMentions = (str) => {
  return str
    .replace(/@\[([^\]]+)\]\([^)]+\)/g, "@$1")
    .replace(/#\[([^\]]+)\]\([^)]+\)/g, "#$1");
};

const Chat = ({ chat }) =>
  chat.map((msg) => (
    <React.Fragment key={Math.random()}>
      <Row style={styles.chatHeader}>
        <Field label="Usuário">{msg.username}</Field>
        <Field label="Data">
          {new Date(msg.createdAt).toLocaleString("pt-BR", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Field>
      </Row>
      <Row style={styles.chatMessage}>
        <Field label="Texto">
          <Text style={styles.subtext}>{reformatMentions(msg.message)}</Text>
        </Field>
      </Row>
    </React.Fragment>
  ));

export default Chat;
